export { useRedirectIfAgeVerificationNotApplicable } from './use-redirect-if-age-verification-not-applicable';
